import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import {minDate} from "../../Constants/Constants"
const AddTKCSOrder = ({ getData, formRef }) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const [company, setCompany] = useState([]);
  const navigate = useNavigate();
  const [product, setProduct] = useState([]);
  const [productId, setProductId] = useState("");
  const [party, setParty] = useState("");
  const [partyName, setPartyName] = useState("");
  const [filterCriteria, setfilterCriteria] = useState({
    company_id: selectedCompanyId ? selectedCompanyId : "",
    product_name_id: productId,
  });
  const [productQuantity, setProductQuantity] = useState([
    { product_name_id: "", po_qty: "" },
  ]);
  const [rowAddData, setRowAddData] = useState({
    company_id: "",
    po_date: "",
    party_name: "",
    product_name_id: "",
    po_quantity: "",
    po_number: "",
    payment_term: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRowAddData(() => {
      return {
        ...rowAddData,
        [name]: value,
      };
    });
  };

  function resetFileds() {
    setRowAddData({
      company_id: "",
      po_date: "",
      party_name: "",
      product_name_id: "",
      po_quantity: "",
      po_number: "",
      payment_term: "",
    });
    setSelectedCompanyId("");
    setProduct([]);
    setProductQuantity([{ product_name_id: "", po_quantity: "" }]);
    setPartyName("");
  }

  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    // console.log(result.data)
    setCompany(result.data);
  };

  useEffect(() => {
    getCompany();
  }, []);

  const getParty = async () => {
    const BASE_URL = SERVER_URL + `/api/tkcs-rate/tkcs-rate/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    // console.log(result.data)
    setParty(result.data);
  };

  useEffect(() => {
    getParty();
  }, []);

  const getProductDetails = async (e) => {
    const companyId = e.target.value ? parseInt(e.target.value) : "";

    // Exit early if companyId is empty
    if (!companyId) {
      setProduct([]);
      setProductId("");
      setfilterCriteria({ product_name_id: "" });
      setSelectedCompanyId(companyId);
      setfilterCriteria((prevFilterCriteria) => ({
        ...prevFilterCriteria,
        company_id: companyId,
      }));
      return;
    }

    setSelectedCompanyId(companyId);
    setfilterCriteria((prevFilterCriteria) => ({
      ...prevFilterCriteria,
      company_id: companyId,
    }));

    const BASE_URL = `${SERVER_URL}/api/product/drop-products/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        company_id: companyId,
      }),
    });
    const result = await res.json();
    setProduct(result.data);
  };

  const handleAddDataSubmit = async (e) => {
    e.preventDefault();
    const { po_date, po_number, payment_term } = rowAddData;

    let BASE_URL = SERVER_URL + `/api/private-order/private-order/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        company_id: selectedCompanyId,
        po_date,
        party_name: partyName,
        po_number,
        payment_term,
        product_quantity_details: productQuantity,
      }),
    });
    const response = await res.json();

    if (res.ok) {
      getData();
      resetFileds();
      console.log(response);
      setTimeout(() => {
        toast.success(response.message);
        formRef.current.reset();
        // navigate("/dashboard");
      }, 1000);
    } else {
      toast.error(response.message);
    }
  };

  const handleAddFields = () => {
    setProductQuantity([
      ...productQuantity,
      { product_name_id: "", po_quantity: "" },
    ]);
  };
  const handleClose = (index) => {
    const values = [...productQuantity];
    values.splice(index, 1);
    setProductQuantity(values);
  };

  const handleChangeInput = (index, event) => {
    const values = [...productQuantity];
    if (event.target.name === "product_name_id") {
      values[index].product_name_id = event.target.value;
    } else {
      values[index].po_qty = event.target.value;
    }
    setProductQuantity(values);
  };

  const handlePartyChange = (e) => {
    setPartyName(e.target.value);
  };

  return (
    <>
      <div
        className="modal custom-modal fade"
        id="exampleModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Add TKCS Order
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFileds}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    {/* <div className="card-title">
                      Add Private Order &nbsp;
                      <span>
                        <button
                          className="btn btn-sm btn-light btn-icon-text border"
                          onClick={handleNavigate}
                        >
                          <i
                            className="mdi mdi-arrow-left"
                            style={{ height: "4px", width: "4px" }}
                          ></i>{" "}
                          Back{" "}
                        </button>
                      </span>
                    </div> */}

                    <form
                      className="form-sample"
                      ref={formRef}
                      onSubmit={handleAddDataSubmit}
                    >
                      {/* <p className="card-description">Personal info</p> */}
                      <div className="row">
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="company_id">Company Name</label>
                            <select
                              type="text"
                              className="form-control form-control-lg"
                              name="company_id"
                              id="company_id"
                              onChange={(e) => getProductDetails(e)}
                              value={selectedCompanyId}
                              required
                            >
                              <option value="">Select Company</option>
                              {company &&
                                company?.length > 0 &&
                                company?.map((item, id) => {
                                  return (
                                    <option
                                      value={item.id}
                                      key={id}
                                    >{`${item.company_name}, ${item.location}`}</option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="party_name">Party Name</label>
                            <select
                              type="text"
                              className="form-control form-control-lg"
                              name="party_name"
                              id="party_name"
                              onChange={handlePartyChange}
                              value={partyName}
                              required
                            >
                              <option value="">Select Party</option>
                              {party &&
                                party?.length > 0 &&
                                party?.map((item, id) => {
                                  return (
                                    <option
                                      value={item.party_name}
                                      key={id}
                                    >{`${item.party_name}`}</option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Pole_number">Po.No</label>
                            <input
                              type="text"
                              className="form-control"
                              name="po_number"
                              id="Pole_number"
                              placeholder="Pole No"
                              value={rowAddData.po_number}
                              onChange={handleChange}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="pole_date">Po Date</label>
                            <input
                              type="date"
                              className="form-control"
                              name="po_date"
                              id="pole_date"
                              max={new Date().toISOString().split("T")[0]}
                              placeholder="Pole Date"
                              value={rowAddData.po_date}
                              onChange={handleChange}
                              required
                              autoComplete="off"
                              min={minDate}
                            />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="terms">Payment Terms</label>
                            <input
                              type="text"
                              className="form-control"
                              name="payment_term"
                              id="terms"
                              placeholder="Payment Terms"
                              value={rowAddData.payment_term}
                              onChange={handleChange}
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        {/* <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Location">Location</label>
                            <input
                              type="text"
                              className="form-control"
                              name="location"
                              id="Location"
                              placeholder="Location"
                              value={rowAddData.location}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="rate">Rate</label>
                            <input
                              type="text"
                              className="form-control"
                              name="rate"
                              id="rate"
                              placeholder="Rate"
                              value={rowAddData.rate}
                              onChange={handleChange}
                            />
                          </div>
                        </div> */}
                        {productQuantity &&
                          productQuantity?.length > 0 &&
                          productQuantity?.map((item, index) => {
                            return (
                              <React.Fragment key={index}>
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label htmlFor="company_id">
                                      Product Size
                                    </label>
                                    <select
                                      className="form-control form-control-lg"
                                      onChange={(event) =>
                                        handleChangeInput(index, event)
                                      }
                                      name="product_name_id"
                                      value={item.product_name_id}
                                      disabled={!selectedCompanyId}
                                      id="product"
                                      required
                                    >
                                      <option value="">
                                        Select Product (All)
                                      </option>
                                      {product &&
                                        product.length > 0 &&
                                        product?.map((item, id) => {
                                          return (
                                            <option
                                              value={item.id}
                                              key={id}
                                            >{`${item.size}`}</option>
                                          );
                                        })}
                                    </select>
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label htmlFor="quantity">
                                      Po Quantity
                                    </label>
                                    <div className="input-group">
                                      <input
                                        type="number"
                                        className="form-control"
                                        name="po_qty"
                                        id="quantity"
                                        placeholder="Po Quantity"
                                        onChange={(event) =>
                                          handleChangeInput(index, event)
                                        }
                                        required
                                        value={item.po_qty}
                                        autoComplete="off"
                                      />
                                      <span className="input-group-append ml-2">
                                        <div className="col-md-2">
                                          {index > 0 ? (
                                            <button
                                              type="button"
                                              title="Remove"
                                              className="btn btn-outline-danger btn-rounded btn-icon"
                                              onClick={() => handleClose(index)}
                                            >
                                              <span className="mdi mdi-close-thick"></span>
                                            </button>
                                          ) : (
                                            <button
                                              type="button"
                                              disabled
                                              className="btn btn-outline-danger btn-rounded btn-icon"
                                            >
                                              <i className="mdi mdi-close" />
                                            </button>
                                          )}
                                        </div>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </React.Fragment>
                            );
                          })}
                        <span className="input-group-append ml-2">
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleAddFields}
                          >
                            Add More
                          </button>
                        </span>
                      </div>
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        // onClick={handleAddDataSubmit}
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddTKCSOrder;
